import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrganisationFeesActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createOrganisationFee = (data): any => action(types.CREATE_ORGANISATION_FEE_REQUESTED, data);

export const updateOrganisationFee = (data): any => action(types.UPDATE_ORGANISATION_FEE_REQUESTED, data);

export const deleteOrganisationFee = (organisationFeeId): any => action(types.UPDATE_ORGANISATION_FEE_REQUESTED, organisationFeeId);

export const getOrganisationFee = (organisationFeeId): any => action(types.GET_ORGANISATION_FEE_REQUESTED, organisationFeeId);

export const getAllOrganisationFees = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORGANISATION_FEES_REQUESTED, {
  pagination,
  compile,
});

export const selectOrganisationFee = (organisationFeeId): any => action(types.SELECT_ORGANISATION_FEE_REQUESTED, {
  currentOrganisationFeeId: organisationFeeId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createOrganisationFeePending: (payload): any => action(types.CREATE_ORGANISATION_FEE_PENDING, payload),
  createOrganisationFeeSuccess: (response): any => {
    const currentOrganisationFee = response.entities.organisationFees[response.result];
    // history.push(`/payment/${currentOrganisationFee.paymentCollection.id}/review`);
    return action(types.CREATE_ORGANISATION_FEE_SUCCESS, {
      organisationFeesById: response.entities.organisationFees,
      currentOrganisationFeeId: response.result,
    });
  },
  updateOrganisationFeePending: (payload): any => action(types.UPDATE_ORGANISATION_FEE_PENDING, payload),
  updateOrganisationFeeSuccess: (response): any => action(types.UPDATE_ORGANISATION_FEE_SUCCESS, {
    organisationFeesById: response.entities.organisationFees,
    currentOrganisationFeeId: response.result,
  }),
  updateOrganisationFeeFailed: (error): any => action(types.UPDATE_ORGANISATION_FEE_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationFeePending: (): any => action(types.UPDATE_ORGANISATION_FEE_PENDING, {}),
  deleteOrganisationFeeSuccess: (response, userId): any => {
    localStorage.set(userId, { currentOrganisationFeeId: null });
    history.push('/organisationFees');

    return action(types.DELETE_ORGANISATION_FEE_SUCCESS, {
      currentOrganisationFeeId: response,
    });
  },
  getOrganisationFeePending: (): any => action(types.GET_ORGANISATION_FEE_PENDING, {}),
  getOrganisationFeeSuccess: (response): any => action(types.GET_ORGANISATION_FEE_SUCCESS, {
    organisationFeesById: response.entities.organisationFees,
    currentOrganisationFeeId: response.result,
  }),
  getOrganisationFeeFailed: (error): any => action(types.GET_ORGANISATION_FEE_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationFeeFailed: (error): any => action(types.UPDATE_ORGANISATION_FEE_FAIL, {
    backendErrors: error,
  }),
  getAllOrganisationFeesPending: (pagination): any => action(types.GET_ALL_ORGANISATION_FEES_PENDING, { pagination }),
  getAllOrganisationFeesSuccess: (response, meta): any => action(types.GET_ALL_ORGANISATION_FEES_SUCCESS, {
    organisationFeesById: response.entities.organisationFees,
    organisationFeeIds: response.result,
    meta,
  }),
  getAllOrganisationFeesFailed: (error): any => action(types.GET_ALL_ORGANISATION_FEES_FAIL, {
    backendErrors: error,
  }),
  createOrganisationFeeFailed: (error): any => action(types.CREATE_ORGANISATION_FEE_FAIL, {
    backendErrors: error,
  }),
};

export default null;
